const parseUChar8 = (data, offset) => data.charCodeAt(offset) & 0xff;

export default parseUChar8;